<template>
  <div class="list-header">
    <div class="bread-list">
      <div style="margin-right:10px;"><i class="el-icon-s-operation"></i></div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">Home</el-breadcrumb-item>
        <el-breadcrumb-item>{{ fromName }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="menuName">{{ menuName }}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="label">{{ label }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="title">（Under Construction...）</div>
    <div class="back_btn">
      <div class="back" @click="back" v-if="label">
        <img src="../../assets/images/banner/back.png" />
        <div class="text">Back</div>
      </div>
    </div>
  </div>
</template>
<script>
import imgs from "./imgs.vue";
export default {
  components: { imgs },
  name: "Bread",
  props: {
    menuName: {
      type: String,
      default: "",
      required: false,
    },
    // fromName: {
    //   type: String,
    //   default: "",
    //   required: false,
    // },
    label: {
      type: String,
      default: "",
      required: false,
    },
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler(val) {
        // this.fromName = this.$route.query.title;
        var newStr = this.$route.query.title.split(" ");
        for (var i = 0; i < newStr.length; i++) {
          newStr[i] =
            newStr[i].slice(0, 1).toUpperCase() +
            newStr[i].slice(1).toLowerCase();
        }
        this.fromName = newStr.join(" ");
      },
    },
    label: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log(`labelBread`, val);
      },
    },
    menuName: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log(`menuNameBread`, val);
      },
    },
    // fromName: {
    //   deep: true,
    //   immediate: true,
    //   handler(val) {
    //     console.log(`fromNameBread`, val);
    //     var newStr = val.split(" ");
    //     for (var i = 0; i < newStr.length; i++) {
    //       newStr[i] =
    //         newStr[i].slice(0, 1).toUpperCase() +
    //         newStr[i].slice(1).toLowerCase();
    //     }
    //     val = newStr.join(" ");
    //     this.fromName = newStr.join(" ");
    //   },
    // },
  },
  data() {
    return {
      fromName: "",
    };
  },
  created() {
    this.fromName = this.$route.query.title;
    var newStr = this.$route.query.title.split(" ");
    for (var i = 0; i < newStr.length; i++) {
      newStr[i] =
        newStr[i].slice(0, 1).toUpperCase() + newStr[i].slice(1).toLowerCase();
    }
    this.$route.query.title = newStr.join(" ");
    this.fromName = newStr.join(" ");
  },
  methods: {
    back() {
      // this.$router.back(-1);
      this.$router.back();
      // this.$router.push({
      //   path:'/detail',
      //   query:{
      //     name:this.$route.query.name,
      //     code:this.$route.query.code
      //   }
      // })
    },
  },
};
</script>
<style lang="less" scoped>
.list-header {
  width: 100%;
  position: relative;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
}
.list-item {
  height: 300px;
  background-color: #f8f9fb;
}
.bread-list {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 19%;
}
.title {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #868686;
  right: 350px;
  position: absolute;
}
.back_btn {
  position: absolute;
  right: 222px;
  .back {
    cursor: pointer;
    display: flex;
    position: relative;
    width: 110px;
    height: 30px;
    background: #e3efff;
    border: 1px solid #032f6d;
    border-radius: 20px;
    justify-content: center;
    align-items: center;

    .text {
      position: absolute;
      left: 45px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #032f6d;
      line-height: 30px;
    }
    img {
      width: 20px;
      height: 17px;
      position: absolute;
      left: 15px;
    }
  }
}

/deep/.el-breadcrumb__inner {
  font-weight: 400;
  .is-link {
    color: #606266;
  }
}
/deep/.el-breadcrumb__inner a,
.el-breadcrumb__inner.is-link {
  font-weight: 400;
  color: #606266;
}
</style>
